module.exports = __webpack_public_path__ + "img/ic_dianziqian.990d3ce7.svg";